// extracted by mini-css-extract-plugin
export var productImage = "_r8-1";
export var viewLink = "_r8-2";
export var wishlistItem = "_r8-0";